'use client';

import { c as _c } from "react/compiler-runtime";
import type { FundingSavedCard } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';
export function FundingSavedCardRow(t0) {
  const $ = _c(28);
  const {
    card,
    busy,
    onSelect
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] !== card.brand) {
    t1 = card.brand.charAt(0).toUpperCase();
    $[0] = card.brand;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const brand = t1 + card.brand.slice(1);
  let t2;
  if ($[2] !== card.cardType || $[3] !== t) {
    t2 = card.cardType === "debit" ? t("card_debit") : card.cardType === "credit" ? t("card_credit") : card.cardType === "prepaid" ? t("card_prepaid") : null;
    $[2] = card.cardType;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const cardType = t2;
  const t3 = busy || !card.availability.active;
  let t4;
  if ($[5] !== card.id || $[6] !== onSelect) {
    t4 = () => onSelect(card.id);
    $[5] = card.id;
    $[6] = onSelect;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" rounded="" imageClassName="object-contain" src="/assets/onramp/method-card.png" alt="" size="size-10" className="bg-transparent" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== brand || $[10] !== card.last4 || $[11] !== t) {
    t6 = t("saved_card_label", {
      brand,
      last4: card.last4
    });
    $[9] = brand;
    $[10] = card.last4;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="text-body font-medium">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== card.availability.active || $[16] !== cardType || $[17] !== t) {
    t8 = card.availability.active ? cardType : t("card_unavailable");
    $[15] = card.availability.active;
    $[16] = cardType;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <span className="text-caption text-foreground-secondary">{t8}</span>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <span className="flex items-center gap-3">{t5}<span className="flex flex-col items-start">{t7}{t9}</span></span>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3 || $[26] !== t4) {
    t11 = <div className="flex items-center gap-2"><AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} className="h-auto min-h-16.5 flex-1 justify-between rounded-control p-3" disabled={t3} onClick={t4}>{t10}</AnimatedButton></div>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}